import JSEncrypt from "jsencrypt";
import fileContent from "../../../help";
import CryptoJS from "crypto-js";

export const generateString = () => {
  const string = `U2FsdGVkX1!kHs^Do#uP+EBH0UzNegBzcXtcU6p+gsQzP3ofl/QHXht5bi2G6c2d/V4VNYdN2I`;

  const newData = {
    sonce: "!kHs^Do#uP",
    newString: string,
  };

  return newData;
};

export function createHash_old(oldString) {
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(fileContent);
  const encrypted = encryptor.encrypt(oldString);
  return encrypted;
}

export function createHash(newString) {
  if (newString.length == 0) {
    newString = process.env.REACT_APP_USER_SECRET_KEY;
  }
  return CryptoJS.SHA256(newString).toString();
}
